<template>
  <h1>Standby while we destroy your session.</h1>
</template>

<script>
export default {
    mounted() {
        this.logout();
    },
    methods: {
        logout(){
            const self = this;
            axios.get('/logout')
            .then(function (response) {
                // console.log(response);
                self.$router.push("/login")

            })
            .catch(function (error) {
                console.log(error);
            });
        }
    },
}
</script>

